import request from 'manager/utils/request';
import { REST_SERVICE } from 'manager/config';

const post = {
  //条件查询快递信息列表
  getPageList(params) {
    return request({
      url: REST_SERVICE.express.getPageList,
      method: 'get',
      params
    });
  },
  // 保存快递订单信息
  saveExpressInfo(params) {
    return request({
      url: REST_SERVICE.express.saveExpressInfo,
      method: 'post',
      params
    });
  },
  //获取配置的文件列表
  getFileList(params) {
    return request({
      url: REST_SERVICE.files.getFileList,
      method: 'get',
      params
    });
  },
  //通过办事大厅代码查询办事大厅
  findByOfficeCode(params) {
    return request({
      url: REST_SERVICE.express.findByOfficeCode,
      method: 'get',
      params
    });
  },

};
export default post;
